export default __webpack_public_path__ + "static/media/perodic-complete.d41c398c.svg";